<template>
  <tr>
    <td>
      <input
        title="Room Name"
        id="room_name"
        type="text"
        ref="name"
        v-model="room.name"
        v-if="room !== null"
        disabled
        v-on:change="updateRoom($event)"
      />
    </td>
    <td><input
        title="Board basis"
        id="room_board_basis"
        type="text"
        ref="board_basis"
        v-model="room.board_basis"
        v-if="room !== null"
        disabled
        v-on:change="updateRoom($event)"
      /></td>
    <td><input
        title="Occupancy"
        id="room_occupancy"
        type="number"
        min="1"
        ref="occupancy"
        class="room-table-price-input"
        v-model="room.occupancy"
        v-if="room !== null"
        disabled
        v-on:change="updateRoom($event)"
      /></td>
    <td><input
        title="Supplement"
        id="room_supplement"
        type="number"
        step="0.01"
        ref="supplement"
        class="room-table-price-input"
        v-model="room.supplement"
        v-if="room !== null"
        v-on:change="updateRoom($event)"
      /></td>
    <td class="table-action">
      <a v-on:click="deleteRoom(room.id)" class="icon icon--delete">Delete</a>
    </td>
  </tr>
</template>
<script>
  export default {
    name: 'RoomTableRow',
    props : {
      // TourAccommodationId: null,
      room: null,
    },
    data () {
      return {
        spinner: false,
        values: null,
      }
    },
    watch: {

    },
    created () {
      this.getRoom()
    },
    methods: {
      getRoom() {
        this.spinner = true
        fetch(this.$api + 'tours/rooms/' + this.$props.room.id, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.values = response.data
        })
        this.spinner = false
      },
      updateRoom(event) {
        this.spinner = true
        fetch(this.$api + 'tours/rooms/' + this.$props.room.id, {
          method: 'POST',
          body: JSON.stringify(this.room),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.getRoom()
          this.errors = response.errors
          if(response.success) {
            this.$notify({
              type: 'success',
              title: event.target.title + ' updated'
            })
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
        })
        this.spinner = false
      },
      deleteRoom(roomID) {
        this.$swal.fire({
          title: 'Are you sure?',
          text: "Are you sure there are not booking for this room!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            this.confirmDeleteRoom(roomID)
          }
        })
      },
      confirmDeleteRoom(roomID) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tours/accommodation/rooms/' + roomID + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.status) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.$emit('deleteRoom')
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } 
          this.$store.dispatch('setLoadStatus')
        });
      }
    }
  }
</script>
